import { render, staticRenderFns } from "./FormationsItem1.vue?vue&type=template&id=bd57b7d4&"
import script from "./FormationsItem1.vue?vue&type=script&lang=js&"
export * from "./FormationsItem1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports